import { BannerLocation, DeliveryEligibility, BannerConfig } from '../types'

/**
 * Banner content configuration for all locations and eligibility types
 */
export const BANNER_CONFIG: Record<
  BannerLocation,
  Record<DeliveryEligibility, BannerConfig | null>
> = {
  homepage: {
    NDD: {
      title: 'Need dinner sorted for tomorrow?',
      subtitle: 'Get your box tomorrow. First delivery is <strong>FREE, save £3.99.</strong>',
      footer: 'Order before 12 pm (midday)',
      ctaText: 'Get your box tomorrow',
    },
    '2DD': {
      title: 'Need food fast?',
      subtitle:
        'Get your box as early as <strong>{deliveryDay}.</strong> First delivery is <strong>FREE, save £3.99.</strong>',
      footer: 'Order before 12 am (midnight)',
      ctaText: 'Get started',
    },
    '2DD_NO_EMERGENCY': {
      title: 'Need food fast?',
      subtitle:
        'Get your box as early as <strong>{deliveryDay}.</strong> First delivery is <strong>FREE, save £3.99.</strong>',
      ctaText: 'Get started',
    },
    '3DD+': null,
  },
  'delivery-days': {
    NDD: {
      message:
        'Get <strong>FREE delivery tomorrow.</strong> Order in the next <span>{countdown}</span>',
    },
    '2DD': {
      message:
        'Get your box as early as <strong>{deliveryDay}.</strong> Order in the next <span>{countdown}</span>',
    },
    '2DD_NO_EMERGENCY': {
      message: 'Get your box as early as <strong>{deliveryDay}.</strong>',
    },
    '3DD+': null,
  },
  'box-summary': {
    NDD: {
      message:
        'Get <strong>FREE delivery tomorrow</strong>. Order in the next <span>{countdown}</span>',
    },
    '2DD': {
      message:
        'Get <strong>FREE delivery for {deliveryDay}</strong>. Order in the next <span>{countdown}</span>',
    },
    '2DD_NO_EMERGENCY': {
      message: 'Get <strong>FREE delivery for {deliveryDay}</strong>.',
    },
    '3DD+': null,
  },
  checkout: {
    NDD: {
      message:
        'You get <span>FREE next day delivery</span> on your first order (usually £3.99) as a welcome treat.',
    },
    '2DD': {
      message:
        'You get <span>FREE delivery on your first order</span> (usually £3.99) as a welcome treat.',
    },
    '2DD_NO_EMERGENCY': {
      message:
        'You get <span>FREE delivery on your first order</span> (usually £3.99) as a welcome treat.',
    },
    '3DD+': {
      message:
        'You get <span>FREE delivery on your first order</span> (usually £3.99) as a welcome treat.',
    },
  },
}
